import "../LinkButtons/LinkButtons.css";

function LinkButtons(props) {
  return <button className="link-btn">{props.name}</button>;
}

export default LinkButtons;
